export var Theme;
(function(Theme) {
    Theme["defaultContentBackgroundColor"] = "#fafafa";
    Theme["defaultContentTextColor"] = "#444444";
    Theme["defaultLinkTextColor"] = "#e65529";
    Theme["defaultMenuBackgroundColor"] = "#656f81";
    Theme["defaultMenuTextColor"] = "#ffffff";
})(Theme || (Theme = {}));
